import { injectIntl } from 'react-intl';

import SocialMediaPayment from './SocialMediaPayment';

export default injectIntl(SocialMediaPayment);
